import { Component, inject, OnInit } from '@angular/core';
import { PanelModule } from 'primeng/panel';
import { AvatarModule } from 'primeng/avatar';
import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';
import { TicketTypes } from '../../../data-services/models/event-bookings/event-booking-detailed.model';
import { Store } from '@ngrx/store';
import {  selectUpcomingEventBookings, selectUserDetails } from '../../../data-services/stores/selectors/user.selectors';
import { UserActions } from '../../../data-services/stores/actions/user.actions';
import { RouterModule } from '@angular/router';
import { EventBookingTileComponent } from '../../../core/event-booking-tile/feature/event-booking-tile.component';

@Component({
    selector: 'app-sidebar-user-info',
    imports: [AsyncPipe,RouterModule,EventBookingTileComponent],
    templateUrl: '../ui/user-info.component.html'
})
export class SidebarUserInfoComponent implements OnInit {
  private readonly _store = inject(Store);
  currentUser$ = this._store.select(selectUserDetails);
  upcomingBookings$ = this._store.select(selectUpcomingEventBookings)

  ngOnInit(): void {
    this._store.dispatch(UserActions.loadUser({ refresh: false }));
  }
  
  public get TicketTypes(): typeof TicketTypes {
    return TicketTypes; 
  }
}
